// components/footer/CandidateHowItWorks.jsx
import React from "react";
import CandidateHowItWorksPicture7 from "../../assets/CandidateHowItWorksPicture7.png";
import CandidateHowItWorksPicture8 from "../../assets/CandidateHowItWorksPicture8.png";
import CandidateHowItWorksPicture9 from "../../assets/CandidateHowItWorksPicture9.png";
import CandidateHowItWorksPicture10 from "../../assets/CandidateHowItWorksPicture10.png";
import CandidateHowItWorksPicture11 from "../../assets/CandidateHowItWorksPicture11.png";
import CandidateHowItWorksPicture12 from "../../assets/CandidateHowItWorksPicture12.png";
import CandidateHowItWorksPicture13 from "../../assets/CandidateHowItWorksPicture13.png";

const CandidateHowItWorks = () => {
    return (
        <div className="min-h-screen bg-darkblue text-lightgray px-6 py-16">
            <div className="max-w-3xl mx-auto">
                <h1 className="text-4xl text-orange text-center mb-8">
                    How It Works – For Candidates
                </h1>

                <div className="space-y-6 text-lg">
                    <p>
                        CareerMission.ai changes the job hunt. Instead of applying and hoping, you take our assessment once, and hiring managers reach out when your profile matches their ideal candidate.
                    </p>
                    <p>
                        You start by completing the CareerMission Personality Inventory. Your results stay in the system permanently, so you'll continue getting opportunities whenever you're marked as open to work.
                    </p>

                    <img src={CandidateHowItWorksPicture8} alt="Assessment questions" className="w-full rounded-lg shadow" />

                    <img src={CandidateHowItWorksPicture13} alt="User Profile" className="block mx-auto max-w-lg rounded-lg shadow" />

                    <p>
                        After finishing the assessment, you'll immediately see your detailed career personality profile.
                    </p>

                    <img src={CandidateHowItWorksPicture7} alt="Candidate profile results" className="w-full rounded-lg shadow" />

                    <p>
                        Hiring managers select a "Superstar Target"—someone who thrived in a role you match. When your profile closely aligns with theirs, you become a top candidate.
                    </p>

                    <img src={CandidateHowItWorksPicture9} alt="Job Post Matches" className="block mx-auto max-w-lg rounded-lg shadow" />

                    <p>
                        Employers see your profile at the top of their list with your similarity score, so you'll be contacted directly, ensuring you always have an advantage.
                    </p>

                    <img src={CandidateHowItWorksPicture10} alt="Similarity to superstar target" className="block mx-auto max-w-sm rounded-lg shadow" />

                    <p>
                        From your own dashboard, you'll see exactly where you rank for various job opportunities.
                    </p>

                    <img src={CandidateHowItWorksPicture11} alt="Your rank for a single job" className="block mx-auto max-w-lg rounded-lg shadow" />

                    <p>
                        You’ll often find multiple roles that match your profile, each with clear ranks and similarity scores.
                    </p>

                    <img src={CandidateHowItWorksPicture12} alt="Multiple job matches" className="block mx-auto max-w-sm rounded-lg shadow" />

                    <p>
                        Say goodbye to traditional job applications—CareerMission.ai ensures your next opportunity finds you.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default CandidateHowItWorks;